import { t } from '@/i18n';
import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: t('pages.application_uniform_gallery.breadcrumb.uniform_label1'),
    link: '/application',
  },
  {
    label: t('pages.application_uniform_gallery.breadcrumb.uniform_label2'),
    link: '/application/history',
  },
  {
    label: t('pages.application_uniform_gallery.breadcrumb.uniform_label3'),
  },
];
